import { ConfirmationNumberRounded, Lock, Pause } from '@mui/icons-material';

import { Button, ButtonVariants } from '@/components';
import { PlayArrowFilledIcon } from '@/icons';
import { EVENT_CONSTANTS } from '@/services';
import {
  playerThunks,
  selectActiveChapterId,
  selectIsEpisodePlaying,
  selectIsEpisodeRedeemRequired,
  selectIsFreeTrialUser,
  useAppDispatch,
  useAppSelector,
} from '@/store';
import { EpisodeCard, Referrer } from '@/types';

export const PlayButton = ({
  episode,
  referrer,
}: {
  episode: EpisodeCard;
  referrer: Referrer;
}) => {
  const dispatch = useAppDispatch();

  const isFreeTrialUser = useAppSelector(selectIsFreeTrialUser);
  const activeChapterId = useAppSelector(selectActiveChapterId);
  const isEpisodePlaying =
    useAppSelector(state => selectIsEpisodePlaying(state, episode.episodeId)) &&
    activeChapterId !== episode.trailerId;
  const isEpisodeRedeemRequired = useAppSelector(state =>
    selectIsEpisodeRedeemRequired(state, episode.episodeId),
  );

  const onPlayNow = () => {
    dispatch(
      playerThunks.episodePlayPressed({
        episodeId: episode.episodeId,
        location: { ...referrer, button: EVENT_CONSTANTS.BUTTON.PLAY_NOW },
        referrer,
      }),
    );
  };

  const onRedeem = () => {
    dispatch(
      playerThunks.initiateRedemption({
        episodeId: episode.episodeId,
        location: { ...referrer, button: EVENT_CONSTANTS.BUTTON.REDEEM },
      }),
    );
  };

  const isEpisodePremium = !!(isFreeTrialUser && episode.isPremium);

  if (isEpisodePremium) {
    return (
      <Button
        variant={ButtonVariants.PREMIUM}
        onClick={e => {
          e?.preventDefault();
          e?.stopPropagation();
          onPlayNow();
        }}
        disabled={episode?.isArchived}
        label="Premium"
        skinny={true}
        fullWidth={false}
        startIcon={<Lock fontSize="small" />}
      />
    );
  }

  return isEpisodeRedeemRequired ? (
    <Button
      label="Redeem"
      variant={ButtonVariants.WHITE}
      onClick={e => {
        e?.preventDefault();
        e?.stopPropagation();
        onRedeem();
      }}
      skinny={true}
      fullWidth={false}
      startIcon={<ConfirmationNumberRounded />}
    />
  ) : (
    <Button
      variant={ButtonVariants.WHITE}
      onClick={e => {
        e?.preventDefault();
        e?.stopPropagation();
        onPlayNow();
      }}
      disabled={episode?.isArchived}
      label={isEpisodePlaying ? 'Pause' : 'Play'}
      skinny={true}
      fullWidth={false}
      startIcon={
        isEpisodePlaying ? (
          <Pause />
        ) : (
          <PlayArrowFilledIcon sx={{ width: 16, height: 16 }} />
        )
      }
    />
  );
};
